import type { JsonDataItem } from '../types';
import type { VisibilityConditionValueTypes } from './converters/target-value/i-target-value-converter';
import type { VisibilityCondition } from './visibility-condition.interfaces';
import { VisibilityConditionBase } from './visibility-condition-base';

export class RiskRatingVisibilityCondition extends VisibilityConditionBase {
  constructor(fieldCondition: VisibilityCondition) {
    super(fieldCondition);
  }

  public runVisibilityCondition(currentData: JsonDataItem): boolean {
    let isHidden = this.defaultIsHidden;

    if (
      this.fieldCondition.sourceFieldId &&
      this.fieldCondition.sourceSubField
    ) {
      const fieldData = currentData[
        this.fieldCondition.sourceFieldId
      ] as JsonDataItem;
      const subField =
        fieldData &&
        Object.keys(fieldData).find((key) => {
          return (
            key.toLowerCase() ===
            this.fieldCondition.sourceSubField?.toString().toLowerCase()
          );
        });

      if (this.fieldCondition.checkNull === true) {
        if (subField) {
          const nullFieldData = fieldData[subField];
          const isBlank = nullFieldData === undefined || nullFieldData === null;
          return this.fieldCondition.negation ? isBlank : !isBlank;
        } else {
          return !!this.fieldCondition.negation;
        }
      }

      if (subField) {
        const subFieldData = fieldData[subField];
        if (this.fieldCondition.targetValueType === 'ENTITY_ID') {
          isHidden = this.determineIsHidden(
            subFieldData as VisibilityConditionValueTypes,
            this.fieldCondition.targetValueId,
            this.fieldCondition.negation,
          );
        } else if (this.fieldCondition.targetValueType === 'STRING') {
          isHidden = this.determineIsHidden(
            subFieldData as VisibilityConditionValueTypes,
            this.fieldCondition.targetValue as VisibilityConditionValueTypes,
            this.fieldCondition.negation,
          );
        }
      } else if (this.fieldCondition.negation !== undefined) {
        isHidden = !this.fieldCondition.negation;
      }
    }

    return isHidden;
  }
}
